// extracted by mini-css-extract-plugin
export default {"a0":"RsBmEkAnnKkgONqpz1Qw","cls1":"pNQjVs6H23dgB8SqjAmv","cls2":"e3XjvuxjJUhGBbsMWIqE pNQjVs6H23dgB8SqjAmv","isPhone":"tig3s7EyTxHuwEcnC5o3","isSelected":"N3r2S4rQsGk42Eh0qZfq"};